import { BaseModel } from "sjs-base-model";

export default class LightActorModel extends BaseModel {
  public readonly uuid: string = "";
  public readonly display_name: string = "";
  public readonly avatar: string = "";

  /*
   * Client-Side properties (Not from API)
   */
  // public noneApiProperties: unknown = null;

  constructor(data: Partial<LightActorModel>) {
    super();

    this.update(data);
  }
}
